const modul = {
	namespaced: true,

	state: {
		diagramVisas: true,		// = initialt defaultvärde
		radtexterVisas: true,	// = initialt defaultvärde

		rullningsbaraElement: [ 	// = initiala defaultvärden
			{ id:'re1', scrollTop: 0 },
			{ id:'re2', scrollTop: 0 },
		],
	},

	mutations: {

		setDiagramVisas(state, nyttVarde)
		{
			// `state` is the local module state
			state.diagramVisas = nyttVarde;
		},

		setRadtexterVisas(state, nyttVarde)
		{
			// `state` is the local module state
			state.radtexterVisas = nyttVarde;
		},

		// rullningsbaraElement muteras via en "root mutation" som används av flera modules/namespaces:
	},

	//actions: { ... },

	//getters: { ... }
};

export { modul as ssoStatestoreKontoutdrag }
